<template>
	<div class="d-flex flex-1 h-100 overflow-auto delegation">
        <v-card class="report-container w-100  p-0" style="border-radius: 12px; margin-bottom: 24px">
            <v-toolbar class="shadow-none" style="flex: unset;" content-class="h-auto">
                <div class="custom-icon-wrapper">
                    <v-icon @click="backToAdminPage()">custom-icon left-arrow-icon</v-icon>
                </div>
                <v-toolbar-title class="size-16 dark-text">{{ $t("res_Title_SystemDelegation") }}</v-toolbar-title>
            </v-toolbar>
            
            <div class="border-top p-4 flex-1 overflow-auto">
                <div class="row align-items-start m-0 gap-2">
                    <div class="p-0" style="width:23%">
                        <v-label class="label_required mb-1">{{ $t("res_Label_FromUser") }}<span> *</span></v-label>
                        <div class="with-absolute-button">
                            <StructureUserSelector :showInternalUsers="true" :showInternalStructures="false"
                                :showExternalStructures="false" :excludeSelf="false" :isMultiple="false"
                                :selectedStructureUser="fromUser" @structureUserSelectChanged="selectFromUser">
                            </StructureUserSelector>
                            <!-- <multi-select class="light-bg" v-model="fromUser" label="name" track-by="id" open-direction="bottom"
                                :options="users" :searchable="true" :loading="loading" :internal-search="false"
                                :clear-on-select="false" :close-on-select="true" :options-limit="300" :max-height="600"
                                :show-no-results="false" :hide-selected="true" :multiple="false" @search-change="asyncFindUser"
                                @select="selectFromUser" @close="users = []" :allow-empty="false" ref="multiselect1">
                                <template slot="option" slot-scope="props">
                                    <div style="height: 50px; width: 100%; display: flex">
                                        <div class="" style="">
                                            <v-avatar color="#eff2f5" size="43">{{ CapitalizeFirstLetter(props.option.name)
                                            }}</v-avatar>
                                        </div>
                                        <div class="ad__box" v-if="props.option.isUser">
                                            <p class="ad__text__bold">{{ props.option.name }}</p>
                                            <p class="ad__text">{{ GetMultiSelectSubHeaderDisplay(props.option) }}</p>
                                        </div>
                                        <div class="ad__box" v-else>
                                            <p class="ad__text__bold">{{ props.option.name }}</p>
                                            <p class="ad__text">{{ GetMultiSelectSubHeaderDisplay(props.option) }}</p>
                                        </div>
                                    </div>
                                </template>
                                <template slot="noOptions" slot-scope="props">
                                    {{ $t("res_Msgs_EmptySearch") }}
                                </template>
                            </multi-select> -->
                            <!-- <button @click="openMultiSelectCtrl(1)"><v-icon>mdi-menu-down</v-icon></button> -->
                        </div>
                    </div>

                    <div class="p-0" style="width:23%">
                        <v-label class="label_required mb-1">{{ $t("res_Label_ToUser") }}<span> *</span></v-label>
                        <div class="with-absolute-button">
                            <StructureUserSelector :showInternalUsers="true" :showInternalStructures="false"
                                :showExternalStructures="false" :excludeSelf="false" :isMultiple="false" 
                                :selectedStructureUser="toUser" @structureUserSelectChanged="selectToUser">
                            </StructureUserSelector>

                            <!-- <multi-select class="light-bg" v-model="toUser" label="name" track-by="id" open-direction="bottom"
                                :options="users" :searchable="true" :loading="loading" :internal-search="false"
                                :clear-on-select="false" :close-on-select="true" :options-limit="300" :max-height="600"
                                :show-no-results="false" :hide-selected="true" :multiple="false" @search-change="asyncFindUser"
                                @select="selectToUser" @close="users = []" :allow-empty="false" ref="multiselect2">
                                <template slot="option" slot-scope="props">
                                    <div style="height: 50px; width: 100%; display: flex">
                                        <div class="" style="">
                                            <v-avatar color="#eff2f5" size="43">{{ CapitalizeFirstLetter(props.option.name)
                                            }}</v-avatar>
                                        </div>
                                        <div class="ad__box" v-if="props.option.isUser">
                                            <p class="ad__text__bold">{{ props.option.name }}</p>
                                            <p class="ad__text">{{ GetMultiSelectSubHeaderDisplay(props.option) }}</p>
                                        </div>
                                        <div class="ad__box" v-else>
                                            <p class="ad__text__bold">{{ props.option.name }}</p>
                                            <p class="ad__text">{{ GetMultiSelectSubHeaderDisplay(props.option) }}</p>
                                        </div>
                                    </div>
                                </template>
                                <template slot="noOptions" slot-scope="props">
                                    {{ $t("res_Msgs_EmptySearch") }}
                                </template>
                            </multi-select> -->
                            <!-- <button @click="openMultiSelectCtrl(2)"><v-icon>mdi-menu-down</v-icon></button> -->
                        </div>
                    </div>

                    <div class="flex-1 p-0">
                        <label class="label_required mb-1">{{ $t("res_Label_FromDate") }}<span> *</span></label>
                        <v-menu content-class="p-0" v-model="from_date_menu" :close-on-content-click="false" transition="scale-transition" offset-y min-width="auto">
                            <template v-slot:activator="{ on }">
                                <v-text-field class="my-1 shrink dtField" label="Select Date" :value="utils.dateFormat(fromDate)" solo v-on="on" append-icon="mdi-calendar">
                                    <template v-slot:append>
                                        <v-icon v-on="on">mdi-calendar</v-icon>
                                    </template>
                                </v-text-field>
                            </template>
                            <v-date-picker v-model="fromDate" @input="from_date_menu = false" :min="new Date().toISOString()"></v-date-picker>
                        </v-menu>
                    </div>

                    <div class="flex-1 p-0">
                        <label class="label_required mb-1">{{ $t("res_Label_ToDate") }}<span> *</span></label>
                        <v-menu content-class="p-0" v-model="to_date_menu" :close-on-content-click="false" transition="scale-transition" offset-y min-width="auto">
                            <template v-slot:activator="{ on }">
                                <v-text-field class="my-1 shrink dtField" label="Select Date" :value="utils.dateFormat(toDate)" solo v-on="on" append-icon="mdi-calendar">
                                    <template v-slot:append>
                                        <v-icon v-on="on">mdi-calendar</v-icon>
                                    </template>
                                </v-text-field>
                            </template>
                            <v-date-picker v-model="toDate" @input="to_date_menu = false" :min="new Date().toISOString()"></v-date-picker>
                        </v-menu>
                    </div>

                    <div class="flex-1 p-0">
                        <v-label class="label_required mb-1">{{ $t("res_Label_Nodes") }}<span> *</span></v-label>
                        <multi-select class="light-bg add-arrow" v-model="node" label="name" placeholder="Select" track-by="id"
                            open-direction="bottom" :options="nodes" :searchable="false" :internal-search="false"
                            :clear-on-select="false" :close-on-select="false" :options-limit="300" :max-height="600"
                            :show-no-results="false" :hide-selected="false" :multiple="true" ref="multiselect4">
                        </multi-select>
                    </div>

                    <div class="col-auto p-0">
                        <v-label></v-label>
                        <v-checkbox class="mt-3 mb-0" v-model="delegationObject.CanSign" :label="allowSignature"></v-checkbox>
                    </div>
                    <div class="col-auto p-0" v-if="constants.client_version_Id == 'ADNOC'">
                        <v-label></v-label>
                        <v-checkbox class="mt-3 mb-0" v-model="delegationObject.CanImpersonateSignature" :label="AllowImpersonateSignature"></v-checkbox>
                    </div>
                </div>

                <div class="mt-2">
                    <v-btn @click="confirmClearForm()" color="light-blue">{{ $t("res_ButtonText_Clear") }}</v-btn>
                    <v-btn @click="addOrUpdateDelegation" color="mx-2 primary">{{ $t((modeText)) }} {{ $t("res_ButtonText_Delegation") }}</v-btn>
                </div>

                <hr>

                <Pagination class="mb-2" :totalCount="pagingData.totalCount" :pageSize="pagingData.pageSize"
                    :pageIndex="pagingData.pageIndex" @pageIndexChanged="pageIndexChanged"></Pagination>

                <v-data-table :mobile-breakpoint="0" class="position-relative white flex-1 d-flex overflow-auto" disable-sort
                    :headers="headers" :items="items" loading-text="loading..." :no-data-text="$t('res_Label_NoData')"
                    :footer-props="{ 'items-per-page-text': 'Items per page' }" caption=""
                    :class="{ 'result_available': items.length != 0 }" header-fixed fixed-header :hide-default-footer="true"
                    :items-per-page="pagingData.pageSize">
                    <template v-slot:item="row">
                        <tr>
                            <td style="display: none">{{ row.item.id }}</td>
                            <td>{{ row.item.fromStructureName }}</td>
                            <td>{{ row.item.fromUser }}</td>
                            <td>{{ row.item.structureName }}</td>
                            <td>{{ row.item.toUser }}</td>
                            <td>{{ utils.dateFormat(row.item.fromDate, 'dd/MM/yy') }}</td>
                            <td>{{ utils.dateFormat(row.item.toDate, 'dd/MM/yy') }}</td>
                            <td>{{ row.item.nodeIds }}</td>
                            <td v-if="row.item.canSign">{{ $t('res_ButtonText_Yes') }}</td>
                            <td v-else>{{ $t('res_ButtonText_No') }}</td> 
                            <td v-if="row.item.canImpersonateSignature && constants.client_version_Id == 'ADNOC'">{{ $t('res_ButtonText_Yes') }}</td>
                            <td v-if="!row.item.canImpersonateSignature && constants.client_version_Id == 'ADNOC'">{{ $t('res_ButtonText_No') }}</td>
                            <td class="text-start">
                                <div class="onhover-display">
                                    <div class="custom-icon-wrapper">
                                        <!--2023: replace the @click event if you do not need confirmation popup -->
                                        <!--@click="getDelegation(row.item.id)" -->
                                        <v-icon @click="confirmGetDelegation(row.item.id)">
                                            custom-icon white-bg edit-icon
                                        </v-icon>
                                    </div>
                                    <div class="custom-icon-wrapper">
                                        <v-icon @click="deleteDelegations(row.item.id)">custom-icon white-bg delete-icon</v-icon>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </template>
                    <template v-slot:no-data>
                        <v-row class="p-5">
                            <img style="width: 118px" src="/assets/images/empty-inbox.svg" alt="" />
                            <p class="m-0">{{ $t("res_Msgs_AlertNoItemsHere") }}</p>
                        </v-row>
                    </template>
                </v-data-table>
            </div>
        </v-card>
        <ConfirmDialog  
                @actionPerformed="confirmDialogActionPerformed"
                :confirmDialogOptions="this.confirmDialogOptions"
             />
    </div>
    
</template>

<script>
import axios from 'axios';
import router from '@/router/index.js'
import constants from '@/assets/js/constants'
import MultiSelect from 'vue-multiselect'
import * as utils from '@/assets/js/common.js'
import Pagination from '@/components/Pagination.vue'
import StructureUserSelector from '@/components/StructureUserSelector.vue'
import $ from 'jquery'
import ConfirmDialog from '@/components/ConfirmDialog.vue'

export default {
    name: 'SystemDelegation',
    components: { MultiSelect, Pagination, StructureUserSelector, ConfirmDialog },
    data: function () {
        return {
            users: [],
            allowSignature: '',
            AllowImpersonateSignature:'',
            delegationObject: {
                FromUserId: 0,
                ToUserId: 0,
                FromStructureId: 0,
                StructureId: 0,
                FromDate: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
                ToDate: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
                NodeIds: "",
                CanSign: false,
                CanImpersonateSignature:false
            },
            constants: constants,
            node: [{ id: 0, name: '' }],
            fromUser: { id: 0, name: '' },
            toUser: { id: 0, name: '' },
            modeText: 'Add',
            delegationId: 0,
            structuresLoading: false,
            loading: false,
            items: [],
            value: null,
            gridHeaders: [],
            dataLoading: false,
            updateDialog: false,
            categories: [{ id: 1, name: this.$t('res_MenuItems_Incoming') }, { id: 2, name: this.$t('res_MenuItems_Outgoing') }, { id: 3, name: this.$t('res_Label_Internal') }],
            nodes: [{ id: 2, name: this.$t('res_TabsName_Inbox') }, { id: 6, name: this.$t('res_TabsName_Sent') },
            { id: 1, name: this.$t('res_TabsName_Draft') }, { id: 9, name: this.$t('res_TabsName_FollowUp') }],
            usersLoading: false,
            options: ['list', 'of', 'options'],
            headers: [
                { text: 'Id', value: 'id', align: ' d-none' },
                { text: this.$t("res_GridHeaders_FromStructure"), value: 'fromStructureName', width: '20%' },
                { text: this.$t("res_GridHeaders_FromUser"), value: 'fromUser', width: '10%' },
                { text: this.$t("res_GridHeaders_ToStructure"), value: 'structureName', width: '20%' },
                { text: this.$t("res_GridHeaders_ToUser"), value: 'toUser', width: '10%' },
                { text: this.$t("res_GridHeaders_FromDate"), value: 'fromDate', width: '7%' },
                { text: this.$t("res_GridHeaders_ToDate"), value: 'toDate', width: '7%' },
                { text: this.$t("res_GridHeaders_Nodes"), value: 'nodeIds', width: '8%' },
                { text: this.$t("res_GridHeaders_CanSign"), value: 'canSign', width: '8%' },
                { text: this.$t("res_Label_ImpersonateSignature"), value: 'canImpersonateSignature', class: constants.client_version_Id!='ADNOC'?'hidden-header':''  },
                { text: '', value: 'actions', width: '10%', sortable: false },
            ],
            from_date_menu: false,
            to_date_menu: false,
            fromDate: window.newDate().toISOString().substr(0, 10),
            formattedFromDate: utils.dateFormat(window.newDate().toISOString().substr(0, 10)),
            toDate: window.newDate().toISOString().substr(0, 10),
           
            pagingData: {
                pageSize: 10,
                pageIndex: 0,
                totalCount: 0
            },
            utils: utils,
            constants: constants,
            confirmDialogOptions: {
                title: '',
                message: '',
                positiveActionButtonText: '',
                negativeActionButtonText: '',
                isPersistent: true,
                visible: false
            },
            delegationIdTemp: 0,
            actionActive: ''
        };
    },
    watch: {
        fromDate() {
            this.formattedFromDate = utils.dateFormat(this.fromDate);
        },
        toDate() {
            
        },
    },
    methods: {
        selectFromUser(item) {
            this.fromUser = item;
            var stringId = item.id.toString();
            this.delegationObject.FromUserId = stringId.split('-')[0];
            this.delegationObject.FromStructureId = stringId.split('-')[1];
        },
        selectToUser(item) {
            this.toUser = item;
            var stringId = item.id.toString();
            this.delegationObject.ToUserId = stringId.split('-')[0];
            this.delegationObject.StructureId = stringId.split('-')[1];
        },
        backToAdminPage(){
            router.push({ name: 'admin' })
        },
        getAllDelegations: function (isResetPaging) {
            if (isResetPaging) {
                this.pagingData.totalCount = 0;
                this.pagingData.pageIndex = 0;
            }

            this.dataLoading = true;
            axios
                .get(
                    constants.baseApiUrl +
                    "Delegation/GetAllActiveSystemDelegations?pageIndex=" +
                    this.pagingData.pageIndex +
                    "&pageSize=" +
                    this.pagingData.pageSize
                )
                .then((res) => {
                    this.items = res.data;
                    this.dataLoading = false;
                    this.items.forEach(element => {
                        var delegationNodes = ''

                        var node_array = element.nodeIds.split(',')
                        node_array.forEach((element, index) => {
                            var nodeObject = this.nodes.find((obj) => obj.id == element)
                            if (index == 0)
                                delegationNodes += nodeObject.name
                            else
                                delegationNodes += ', ' + nodeObject.name
                        });
                        element.nodeIds = delegationNodes;
                    });

                    axios.get(constants.baseApiUrl + "Delegation/GetAllActiveSystemDelegations??pageIndex=" +
                        this.pagingData.pageIndex + "&pageSize=" + this.pagingData.pageSize + "&countOnly=true")
                        .then((res) => {
                            if (res.data[0].numberOfRows != 0) {
                                this.pagingData.totalCount = parseInt(res.data[0].numberOfRows);

                            }
                        })
                        .catch((err) => console.warn(err));
                })
                .catch((err) => console.warn(err));
        },
        deleteDelegations: function (Id) {
            window.showInformation(this.$t("res_Msgs_Confirmation"), this.$t("res_Msgs_DelegateDeleteConfirmation"), () => {
                axios.post(constants.baseApiUrl + 'Delegation/SystemDelegationDelete?delegationId=' + Id)
                    .then((res) => {
                        window.showAlert("res_Msgs_DelegateDeletion", 'success');
                        this.getAllDelegations();
                    })
                    .catch((err) => console.warn(err))
                    .finally(() => this.loading = false)

            }, () => { })
        },
        confirmDialogActionPerformed (result){
            if(result && result.confirmed) {
                if (this.actionActive == 'edit') {
                    this.delegationId = this.delegationIdTemp;
                    this.getDelegation(this.delegationId);
                } else if (this.actionActive == 'clear') {
                    this.clearForm();
                }
            } else if(this.actionActive == 'edit') {
                this.delegationIdTemp = 0;
            }
            this.confirmDialogOptions.visible = false;
        },
        confirmGetDelegation(id){
            if (this.delegationId > 0) {
                this.delegationIdTemp = id;
                this.actionActive = 'edit';
                this.confirmDialogOptions.message = this.$t('res_Msg_ConfirmationModifyChanges')
                this.confirmDialogOptions.visible = true;
            } else {
                this.getDelegation(id);
            }
        },
        getDelegation: function (Id) {
            this.modeText = 'Update';
            this.delegationId = Id;
            axios.get(constants.baseApiUrl + "Delegation/GetByDelegationId?delegationId=" + Id)
                .then(res => {
                    if (res.data != null) {
                        this.setEditValues(res.data);
                    }
                })
                .catch(err => console.warn(err))
        },
        setEditValues: function (item) {
            var fromDate = new Date(item.fromDate);
            var toDate = new Date(item.toDate);
            this.fromDate = new Date(fromDate - (new Date()).getTimezoneOffset() * 60000).toISOString().slice(0, 10);
            this.toDate = new Date(toDate - (new Date()).getTimezoneOffset() * 60000).toISOString().slice(0, 10);

            //Set Can Sign
            this.delegationObject.CanSign = item.canSign;
            this.delegationObject.CanImpersonateSignature = item.canImpersonateSignature;
            //Setting Node
            this.node = [];
            let obj = {
                id: 0,
                name: ''
            }
            this.node.push(obj)

            var node_array = item.nodeIds.split(',');
            node_array.forEach(element => {
                var nodeObject = this.nodes.find((obj) => obj.id == element);
                this.node.push(nodeObject)
            });

            //Setting From User
            this.fromUsers = []
            let fromUserObj = {
                id: item.fromUserId + '-' + item.fromStructureId,
                name: item.fromUser
            }
            this.fromUsers.push(fromUserObj);
            this.fromUser = { id: item.fromUserId, name: item.fromUser };
            this.delegationObject.FromStructureId = item.fromStructureId
            this.delegationObject.FromUserId = item.fromUserId

            //Setting To User
            this.toUsers = []
            let toUserObj = {
                id: item.toUserId + '-' + item.structureId,
                name: item.toUser
            }
            this.toUsers.push(toUserObj);
            this.toUser = { id: item.toUserId, name: item.toUser };
            this.delegationObject.StructureId = item.structureId
            this.delegationObject.ToUserId = item.toUserId
        },
        confirmClearForm(){
            if (this.delegationId > 0) {
                this.actionActive = 'clear';
                this.confirmDialogOptions.message = this.$t('res_Msg_ConfirmationModifyChanges')
                this.confirmDialogOptions.visible = true;
            } else {
                this.clearForm();
            }
        },
        clearForm: function () {
            let today = new Date();
            let sevenDaysLater = new Date(today.getTime() + 7 * 24 * 60 * 60 * 1000);

            this.modeText = 'Add';
            this.delegationObject.NodeIds = '';
            this.delegationObject.FromUserId = 0;
            this.delegationObject.ToUserId = 0;
            this.delegationObject.StructureId = 0;
            this.delegationObject.FromStructureId = 0;
            this.fromDate = today.toISOString().slice(0, 10);
            this.toDate = sevenDaysLater.toISOString().slice(0, 10);
            this.delegationObject.CanSign = false
            this.delegationObject.CanImpersonateSignature = false  
            this.delegationId = 0;
            this.delegationIdTemp = 0;
            // this.structures = [];
            this.fromUsers = [];
            this.toUsers = [];
            this.node = [{ id: 0, name: '' }],
                this.fromUser = { id: 0, name: '' },
                this.toUser = { id: 0, name: '' }
            this.structure = { id: 0, isUser: false, name: '' }
        },
        addOrUpdateDelegation: function () {
            var allNodes = '';
            this.node.forEach(function (element, index) {
                if (index == 1) {
                    allNodes += element.id
                }
                if (index > 1) {
                    allNodes += "," + element.id
                }
            });

            this.delegationObject.NodeIds = allNodes;

            if (this.modeText == 'Add')
                this.addDelegation()
            else
                this.updateDelegation()
        },
        addDelegation: function () {
            if (this.delegationObject.FromUserId == 0 || this.delegationObject.ToUserId == 0
                || this.delegationObject.NodeIds == ''
                || this.delegationObject.StructureId == 0 || this.delegationObject.FromStructureId == 0) {
                window.showAlert("res_Msgs_FillRequired", 'warning')
            }
            else if (new Date(this.fromDate) > new Date(this.toDate)) {
                window.showAlert("res_Msgs_DelegationDatesValidation", "warning")
            }
            else if (this.delegationObject.FromUserId == this.delegationObject.ToUserId) {
                window.showAlert('res_Msgs_SameUserCantBeDelegated', 'warning')
            }
            else {
                let myobj = this.delegationObject;
                myobj.FromDate = this.fromDate;
                myobj.ToDate = this.toDate;

                axios.post(constants.baseApiUrl + 'Delegation/SystemDelegationInsert', this.delegationObject)
                    .then(res => {
                        if (res.data == 1) {
                            window.showAlert('res_Msgs_UserExist', 'warning')
                        }
                        else if (res.data == 2) {
                            window.showAlert('res_Msgs_IncorrectDuration', 'warning')
                        }
                        else if (res.data == 3) {
                            window.showAlert('res_Msgs_SameCategoryAssignationValidation', 'warning')
                        }
                        else if (this.delegationObject.FromUserId == this.delegationObject.ToUserId) {
                            window.showAlert('res_Msgs_SameUserCantBeDelegated', 'warning')
                        }
                        else {
                            window.showAlert("res_Msgs_DelegateAddition", 'success')
                            this.getAllDelegations()
                            this.clearForm()
                        }
                    })
                    .catch(err => console.warn(err))
            }
        },
        updateDelegation: function () {
            if (this.delegationObject.FromUserId == 0 || this.delegationObject.ToUserId == 0
                || this.delegationObject.NodeIds == ''
                || this.delegationObject.StructureId == 0 || this.delegationObject.FromStructureId == 0) {
                window.showAlert("res_Msgs_FillRequired", 'warning')
            }
            else if (new Date(this.fromDate) > new Date(this.toDate)) {
                window.showAlert("res_Msgs_DelegationDatesValidation", "warning")
            }
            else if (this.delegationObject.FromUserId == this.delegationObject.ToUserId) {
                window.showAlert('res_Msgs_SameUserCantBeDelegated', 'warning')
            }
            else {
                let myobj = this.delegationObject;
                myobj.Id = this.delegationId;
                myobj.FromDate = this.fromDate;
                myobj.ToDate = this.toDate;

                axios.post(constants.baseApiUrl + 'Delegation/SystemDelegationUpdate', myobj)
                    .then(res => {
                        if (res.data == 1) {
                            window.showAlert('res_Msgs_UserDelegatedAlready', 'warning')
                        }
                        else if (res.data == 2) {
                            window.showAlert('res_Msgs_IncorrectDuration', 'warning')
                        }
                        else if (res.data == 3) {
                            window.showAlert('res_Msgs_SomeCategoryAltreadySelected', 'warning')
                        }
                        else {
                            window.showAlert("res_Msgs_DelegationUpdation", 'success')
                            this.getAllDelegations()
                            this.clearForm()
                        }
                    })
                    .catch(err => console.warn(err))
            }
        },
        CapitalizeFirstLetter(str) {
            return utils.CapitalizeFirstLetter(str)
        },
        GetMultiSelectSubHeaderDisplay(options) {
            return utils.GetMultiSelectSubHeaderDisplay(options)
        },
        openMultiSelectCtrl(id) {
            if (id === 1) this.$refs.multiselect1.activate()
            else if (id === 2) this.$refs.multiselect2.activate()
            else if (id === 3) this.$refs.multiselect3.activate()
            else if (id === 4) this.$refs.multiselect4.activate()
        },
        pageIndexChanged(pagingData) {
            this.pagingData.pageSize = pagingData.pageSize;
            this.pagingData.pageIndex = pagingData.pageIndex;

            this.getAllDelegations();
        }
    },
    mounted: function () {
        $(".v-data-footer__pagination").insertAfter($(".v-data-footer__icons-before"));
        this.allowSignature = this.$t("res_Label_AllowSignature");
        this.AllowImpersonateSignature = window.translate("res_Label_AllowImpersonateSignature")

        this.clearForm()
        this.getAllDelegations()
    },
}
</script>

<style>
.dtField .v-input__slot {
    height: 40px !important;
}
.hidden-header { display: none; }
</style>